import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2AuditService } from '@fi-shared/checklist/fi-checklist2-audit/fi-checklist2-audit.service';
import { FiChecklist2AuditListComponent } from './fi-checklist2-audit-list/fi-checklist2-audit-list.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiChecklist2ListModule } from '@fi-shared/checklist/fi-checklist2-list/fi-checklist2-list.module';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiChecklist2AuditListTablePerUnitComponent } from '@fi-shared/checklist/fi-checklist2-audit/fi-checklist2-audit-list/fi-checklist2-audit-list-table-per-unit/fi-checklist2-audit-list-table-per-unit.component';
import { FiChecklist2ListColumnDefsModule } from '@fi-shared/checklist/fi-checklist2-list-column-defs/fi-checklist2-list-column-defs.module';
import { FiChecklist2AuditListExtendedSearchComponent } from '@fi-shared/checklist/fi-checklist2-audit/fi-checklist2-audit-list-extended-search/fi-checklist2-audit-list-extended-search.component';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        FiChecklist2ListModule,
        FiItemsListModule,
        FiLocalSearch2Module,
        FiWrapperTableModule,
        FiWhenScrolledModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        MatSortModule,
        MatTableModule,
        FiChecklist2ListColumnDefsModule,
    ],
    declarations: [
        FiChecklist2AuditListComponent,
        FiChecklist2AuditListTablePerUnitComponent,
        FiChecklist2AuditListExtendedSearchComponent,
    ],
    providers: [FiChecklist2AuditService],
})
export class FiChecklist2AuditModule {}
